import React, { useCallback, useEffect, useState } from "react";
import { StatusEnum } from "../../hoc/with-status";

import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { useParams } from "react-router";
import { BB_BGC_INFORMATION_COLLECTION_URL, buildUrl } from "../../config/urls";
import { getSettings } from "../../helpers/get-settings";
import useArb from "../../hooks/use-arb";
import { BGCInformationProps } from "./types";

export const BGCInfoTaskCardButton = ({ status }: BGCInformationProps) => {
  const bundle = useArb("HVHChecklistPantherResource");
  const [bgcInfoCollectLink, setBGCInfoCollectLink] = useState<string>("");

  const bgcInformationButtonText = bundle.getMessage("Checklist-MainPage-BGC-ButtonText");

  const { applicationId, requisitionId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();

  const buildBGCInfoCollectLink = useCallback(async () => {
    const settings = await getSettings();
    const url = BB_BGC_INFORMATION_COLLECTION_URL[settings.stage];
    setBGCInfoCollectLink(buildUrl(url, { applicationId, requisitionId }));
  }, []);

  useEffect(() => {
    buildBGCInfoCollectLink();
  }, []);

  const redirect = useCallback(() => {
    window.open(bgcInfoCollectLink, "_blank");
  }, [bgcInfoCollectLink]);

  return (
    <Button variant={ButtonVariant.Primary} onClick={redirect} disabled={status !== StatusEnum.AWAITING_CANDIDATE_INFO}>
      {bgcInformationButtonText}
    </Button>
  );
};
